import { createContext } from "react";
import IBaseListingResponse from "../../../utils/api/base-listing-response";
import { DEFAULT_FUNCTION, DEFAULT_QUERY } from "../../../utils/helpers/constants";
import { IShelfQuery } from "../../../models/wms/shelf/query";
import { IShelf, IShelfDetails } from "../../../models/wms/shelf/response";
import { ICreateShelf, IUpdateShelf } from "../../../models/wms/shelf/request";

export type ShelfLoading =
  | "list"
  | "details"
  | "create"
  | "update"
  | "delete";

export interface IInternalState {
  loading: ShelfLoading[];
  list?: IBaseListingResponse<IShelf>;
  query: IShelfQuery;
  details?: IShelfDetails;
}

export const internalState: IInternalState = {
  loading: [],
  query: DEFAULT_QUERY,
};

export interface IExternalState extends IInternalState {
  actions: {
    getData: () => void;
    getDetails: (id: number) => void;
    setDetails: (data?: IShelfDetails) => void;
    createShelf: (request: ICreateShelf) => void;
    updateShelf: (id: number, request: IUpdateShelf) => void;
    deleteShelf: (id: number) => void;
    reorderShelf: (id: number, pickSequence: number) => void;
    setSearch: (search?: string) => void;
    setQuery: (query: IShelfQuery) => void;
  };
}

export const externalState: IExternalState = {
  ...internalState,
  actions: {
    getData: DEFAULT_FUNCTION,
    getDetails: DEFAULT_FUNCTION,
    setDetails: DEFAULT_FUNCTION,
    createShelf: DEFAULT_FUNCTION,
    updateShelf: DEFAULT_FUNCTION,
    deleteShelf: DEFAULT_FUNCTION,
    reorderShelf: DEFAULT_FUNCTION,
    setSearch: DEFAULT_FUNCTION,
    setQuery: DEFAULT_FUNCTION,
  },
};

const ShelfContext = createContext(externalState);
export default ShelfContext;
